import React from "react";
import { PLAN_KEYS, PLAN_CONFIG } from "./shared/plan";
import { trackEvent } from "./analytics";

const TRUST_BADGES = [
  "CSRD & ESRS workflow",
  "Audit-ready evidence trail",
  "Board and investor reporting",
  "AI-assisted disclosure drafting"
];

const VALUE_METRICS = [
  { value: "80%", label: "faster first-draft reporting cycles" },
  { value: "3x", label: "clearer visibility into ESG gaps" },
  { value: "1", label: "workspace for data, drafts, gaps, and exports" }
];

const INVESTOR_POINTS = [
  "Large regulatory tailwind from CSRD, ESRS, and supplier ESG pressure",
  "SaaS model designed for recurring reporting cycles and expansion across teams",
  "AI layer turns fragmented ESG inputs into structured, decision-ready outputs",
  "Built for SMEs, consultants, sustainability teams, and finance leaders"
];

const SECURITY_ITEMS = [
  "Role-based workflows",
  "Structured ESG data capture",
  "Reviewable AI outputs",
  "Export-ready reporting packs"
];

const STARTER_CTA =
  PLAN_CONFIG[PLAN_KEYS.STARTER]?.cta || "Start for €49/month";

const ASSESSMENT_PATH = "/csrd-readiness-assessment";

export default function EcovantaLandingPage() {
  const goToSignup = (plan = PLAN_KEYS.STARTER) => {
    window.location.href = `/?signup=true&plan=${plan}`;
  };

  //const goToDemo = () => {
   // window.location.href =
    //  "mailto:hello@onedigitale.com ?subject=Ecovanta Demo Request";
  //};
const goToDemo = () => {
  trackEvent("demo_click", {
    source: "landing_page"
  });

  window.location.href =
    "mailto:hello@onedigitale.com?subject=Ecovanta Demo Request";
};

const trackAssessmentClick = (source) => {
  trackEvent("assessment_cta_click", {
    source,
    path: window.location.pathname
  });
};

  const orderedPlans = [
    PLAN_KEYS.STARTER,
    PLAN_KEYS.PRO,
    PLAN_KEYS.ENTERPRISE
  ].map((key) => PLAN_CONFIG[key]);

  return (
    <div
      style={{
        fontFamily:
          'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        background: "#f8fafc",
        color: "#0f172a",
        minHeight: "100vh"
      }}
    >
      <header style={headerStyle}>
        <div style={headerInnerStyle}>
          <a href="#top" style={brandStyle}>
            <img
              src="/logo/ecovanta-logo.png"
              alt="Ecovanta Logo"
              style={{
                width: "42px",
                height: "42px",
                objectFit: "contain"
              }}
            />
            <div>
              <div style={{ fontWeight: "900", fontSize: "18px" }}>
                ecovanta.ai
              </div>
              <div style={{ fontSize: "12px", color: "#64748b" }}>
                AI ESG reporting infrastructure
              </div>
            </div>
          </a>

          <nav style={navStyle}>
            <a href="#platform" style={navLinkStyle}>
              Platform
            </a>
            <a href="#traction" style={navLinkStyle}>
              Why now
            </a>
            <a href="#workflow" style={navLinkStyle}>
              Workflow
            </a>
            <a href="#pricing" style={navLinkStyle}>
              Pricing
            </a>
            <button style={secondaryButtonStyle} onClick={goToDemo}>
              Book Demo
            </button>
            <button
              style={primaryButtonStyle}
              onClick={() => goToSignup(PLAN_KEYS.STARTER)}
            >
              {STARTER_CTA}
            </button>
          </nav>
        </div>
      </header>

      <main id="top">
        <section style={heroSectionStyle}>
          <div style={heroGridStyle}>
            <div>
              <div style={eyebrowPillStyle}>
                ESG reporting infrastructure for the CSRD era
              </div>

              <h1 style={heroTitleStyle}>
                Investor-grade ESG and CSRD reporting, powered by AI.
              </h1>

              <p style={heroTextStyle}>
                Ecovanta helps companies transform fragmented sustainability
                inputs into structured ESRS-aligned disclosures, compliance gap
                insights, and board-ready reports faster than traditional manual
                reporting cycles.
              </p>

              <div style={ctaRowStyle}>
              <button
                style={primaryButtonLargeStyle}
                onClick={() => goToSignup(PLAN_KEYS.STARTER)}
              >
                {STARTER_CTA}
              </button>

              <a
                href={ASSESSMENT_PATH}
                style={{
                  ...secondaryButtonLargeStyle,
                  textDecoration: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid #10b981",
                  color: "#047857",
                  background: "#ecfdf5"
                }}
                onClick={() => trackAssessmentClick("landing_page_hero")}
              >
                Take the CSRD Readiness Assessment
              </a>

              <button style={secondaryButtonLargeStyle} onClick={goToDemo}>
                Book Investor / Enterprise Demo
              </button>
            </div>

            <a
              href="/esg-maturity-benchmark"
              style={{
                display: "inline-block",
                marginTop: "6px",
                padding: "12px 20px",
                borderRadius: "8px",
                background: "#0f766e",
                color: "#ffffff",
                textDecoration: "none",
                fontWeight: 600
              }}
            >
              Start ESG Maturity Benchmark
            </a>
<p
  style={{
    marginTop: "4px",
    fontSize: "14px",
    color: "#64748b",
    textAlign: "left"
  }}
>
  Evaluate ESG maturity across Governance, Strategy,
  Risk, Environment, Social, Reporting and Technology.
</p>
              <div style={badgeGridStyle}>
                {TRUST_BADGES.map((badge) => (
                  <span key={badge} style={trustBadgeStyle}>
                    {badge}
                  </span>
                ))}
              </div>
            </div>

            <div style={dashboardShellStyle}>
              <div style={dashboardHeaderStyle}>
                <div>
                  <div style={{ color: "#ffffff", fontWeight: "900" }}>
                    Ecovanta Command Center
                  </div>
                  <div style={{ color: "#94a3b8", fontSize: "12px" }}>
                    Executive ESG readiness snapshot
                  </div>
                </div>
                <div style={{ display: "flex", gap: "8px" }}>
                  <span style={dot("#ef4444")} />
                  <span style={dot("#f59e0b")} />
                  <span style={dot("#10b981")} />
                </div>
              </div>

              <div style={{ padding: "22px" }}>
                <div style={metricGridStyle}>
                  <MetricCard title="CSRD Readiness" value="84%" accent="#7c3aed" />
                  <MetricCard title="ESG Score" value="78" accent="#10b981" />
                  <MetricCard title="Open Gaps" value="12" accent="#f59e0b" />
                </div>

                <div style={recommendationStyle}>
                  <div style={recommendationHeaderStyle}>
                    <span>AI-generated board insight</span>
                    <span style={priorityPillStyle}>High Priority</span>
                  </div>
                  <div style={{ color: "#475569", lineHeight: 1.65 }}>
                    Define a climate transition plan with Scope 1-3 targets,
                    owner accountability, capital allocation assumptions, and
                    KPI tracking aligned with ESRS E1.
                  </div>
                </div>

                <div style={panelGridStyle}>
                  <MiniPanel title="Benchmark Position">
                    <div style={barRow}>
                      <span>Company</span>
                      <div style={barTrack}>
                        <div style={{ ...barFill, width: "78%", background: "#5b8db8" }} />
                      </div>
                    </div>
                    <div style={barRow}>
                      <span>Sector Avg</span>
                      <div style={barTrack}>
                        <div style={{ ...barFill, width: "65%", background: "#c7a86d" }} />
                      </div>
                    </div>
                    <div style={barRow}>
                      <span>Top Quartile</span>
                      <div style={barTrack}>
                        <div style={{ ...barFill, width: "82%", background: "#6fa287" }} />
                      </div>
                    </div>
                  </MiniPanel>

                  <MiniPanel title="Disclosure Gaps">
                    <div style={{ color: "#475569", lineHeight: 1.8 }}>
                      - Scope 3 methodology missing
                      <br />- Targets not disclosed
                      <br />- Workforce KPIs incomplete
                    </div>
                  </MiniPanel>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ padding: "0 24px 56px 24px" }}>
          <div style={proofStripStyle}>
            {VALUE_METRICS.map((metric) => (
              <div key={metric.label} style={proofMetricStyle}>
                <div style={proofValueStyle}>{metric.value}</div>
                <div style={proofLabelStyle}>{metric.label}</div>
              </div>
            ))}
          </div>
        </section>

        <section style={{ padding: "0 24px 72px 24px" }}>
  <div
    style={{
      maxWidth: "1200px",
      margin: "0 auto",
      background:
        "linear-gradient(135deg,#ffffff 0%,#f8fafc 55%,#ecfdf5 100%)",
      border: "1px solid #d1fae5",
      borderRadius: "28px",
      padding: "42px",
      boxShadow: "0 24px 60px rgba(15,23,42,0.09)"
    }}
  >
    <div
      style={{
        color: "#047857",
        fontWeight: "900",
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        marginBottom: "12px"
      }}
    >
      CSRD READINESS ASSESSMENT
    </div>

    <h2
      style={{
        fontSize: "42px",
        marginBottom: "16px",
        color: "#0f172a"
      }}
    >
      Check your organization's CSRD readiness in 3 minutes
    </h2>

    <p
      style={{
        color: "#475569",
        lineHeight: 1.8,
        fontSize: "18px",
        maxWidth: "900px"
      }}
    >
      Answer 10 practical questions and receive an instant readiness score
      covering ESG governance, double materiality, ESRS preparedness,
      emissions reporting, disclosure maturity, and AI-assisted reporting
      readiness.
    </p>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
        gap: "14px",
        margin: "24px 0"
      }}
    >
      <div>✓ ESG data ownership maturity</div>
      <div>✓ Double materiality readiness</div>
      <div>✓ ESRS disclosure preparedness</div>
      <div>✓ AI reporting readiness</div>
    </div>

    <div
      style={{
        marginBottom: "20px",
        color: "#64748b",
        fontSize: "14px"
      }}
    >
      The assessment is available without payment. Ecovanta platform access
      starts with the paid Starter plan.
    </div>

    <a
      href={ASSESSMENT_PATH}
      onClick={() =>
        trackAssessmentClick("landing_page_assessment_card")
      }
      style={{
        ...primaryButtonLargeStyle,
        textDecoration: "none",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#047857"
      }}
    >
      Start the Assessment
    </a>
  </div>
</section>

        <section id="traction" style={{ padding: "0 24px 72px 24px" }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <SectionHeader
              eyebrow="Why Ecovanta, why now"
              title="A regulatory wedge for a scalable ESG intelligence platform"
              text="Companies are under pressure to produce reliable sustainability disclosures, but most teams still depend on spreadsheets, consultants, and fragmented evidence. Ecovanta turns that pain into a repeatable software workflow."
            />

            <div style={investorGridStyle}>
              <div style={investorCardStyle}>
                <h3 style={cardTitleStyle}>Investor thesis</h3>
                <p style={cardTextStyle}>
                  Ecovanta is positioned at the intersection of regulation,
                  enterprise reporting, and applied AI. The platform starts with
                  CSRD and ESRS reporting, then expands into benchmarking, risk
                  intelligence, supplier ESG workflows, and continuous disclosure
                  management.
                </p>
                <div style={{ display: "grid", gap: "12px", marginTop: "22px" }}>
                  {INVESTOR_POINTS.map((point) => (
                    <CheckRow key={point} text={point} />
                  ))}
                </div>
              </div>

              <div style={moatCardStyle}>
                <h3 style={{ ...cardTitleStyle, color: "#ffffff" }}>
                  Product wedge
                </h3>
                <div style={moatListStyle}>
                  <MoatItem title="Data capture" text="Structured questionnaires convert unorganized ESG inputs into normalized datasets." />
                  <MoatItem title="AI drafting" text="Guided disclosure generation helps teams create consistent, reviewable reporting narratives." />
                  <MoatItem title="Gap analytics" text="Dashboards expose missing evidence, incomplete metrics, and disclosure readiness risks." />
                  <MoatItem title="Exports" text="Professional reporting packs support management, board, investor, and compliance conversations." />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="platform" style={whiteSectionStyle}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <SectionHeader
              eyebrow="Platform"
              title="Built for serious ESG reporting teams"
              text="Ecovanta combines structured ESG data collection, AI-assisted drafting, evidence review, analytics, and export-ready reporting in one workspace."
            />

            <div style={featureGridStyle}>
              <FeatureCard
                icon="AI"
                title="AI ESG Disclosure Drafting"
                text="Generate structured ESRS-style disclosures, executive summaries, improvement actions, and KPI recommendations from company inputs."
              />
              <FeatureCard
                icon="DM"
                title="Double Materiality Engine"
                text="Assess impact and financial materiality through a scoring workflow designed for clear prioritization and management review."
              />
              <FeatureCard
                icon="GC"
                title="Gap & Compliance Dashboard"
                text="Identify missing disclosures, weak evidence, incomplete metrics, and priority remediation actions before review deadlines."
              />
              <FeatureCard
                icon="BI"
                title="Benchmark Intelligence"
                text="Compare ESG performance against sector reference points and communicate progress to executives, investors, and clients."
              />
              <FeatureCard
                icon="ER"
                title="Export-Ready Reports"
                text="Turn ESG data into professional reporting packs for internal governance, funders, enterprise customers, and compliance workflows."
              />
              <FeatureCard
                icon="WF"
                title="Workflow for Teams"
                text="Support collaboration across sustainability, finance, HR, operations, and leadership without losing track of ownership."
              />
            </div>
          </div>
        </section>

        <section id="workflow" style={{ padding: "72px 24px" }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <SectionHeader
              eyebrow="Workflow"
              title="From ESG data to investor-ready reports"
              text="A repeatable workflow designed to reduce manual work, improve disclosure quality, and give leadership a clear view of ESG readiness."
            />

            <div style={stepGridStyle}>
              <StepCard
                number="01"
                title="Collect structured ESG data"
                text="Capture governance, climate, workforce, social, and business conduct inputs using a guided ESG reporting workflow."
              />
              <StepCard
                number="02"
                title="Generate AI-assisted disclosures"
                text="Create report narratives, identify weak sections, and receive practical recommendations with owners, KPIs, and priorities."
              />
              <StepCard
                number="03"
                title="Review gaps and evidence"
                text="Track completeness by topic, surface missing data, and prepare teams for management, investor, or assurance review."
              />
              <StepCard
                number="04"
                title="Export board-ready reports"
                text="Deliver professional ESG reports and decision packs for leadership, clients, funders, and compliance stakeholders."
              />
            </div>
          </div>
        </section>

        <section style={darkBandStyle}>
          <div style={darkBandGridStyle}>
            <div>
              <div style={darkEyebrowStyle}>Enterprise readiness</div>
              <h2 style={darkTitleStyle}>
                Designed for credible reporting, not black-box automation.
              </h2>
              <p style={darkTextStyle}>
                Ecovanta keeps humans in control. AI accelerates drafting and
                analysis, while teams review, refine, and approve outputs before
                they become external disclosures.
              </p>
            </div>
            <div style={securityGridStyle}>
              {SECURITY_ITEMS.map((item) => (
                <div key={item} style={securityItemStyle}>
                  {item}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="pricing" style={{ padding: "72px 24px" }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <SectionHeader
              eyebrow="Pricing"
              title="Simple plans for teams moving from spreadsheets to ESG intelligence"
              text="Start with the Starter plan, upgrade for deeper reporting capabilities, or work with Ecovanta on an enterprise ESG reporting deployment."
            />

            <div style={pricingGridStyle}>
              {orderedPlans.filter(Boolean).map((plan) => (
                <PricingCard
                  key={plan.key}
                  name={plan.name}
                  price={plan.priceDisplay || plan.monthlyPrice}
                  description={plan.description || plan.bestFor}
                  features={plan.marketingFeatures || plan.features || []}
                  highlighted={Boolean(plan.highlighted)}
                  buttonText={
                    plan.cta ||
                    (plan.key === PLAN_KEYS.ENTERPRISE
                      ? "Contact Sales"
                      : `Start ${plan.name}`)
                  }
                  onAction={
                    plan.key === PLAN_KEYS.ENTERPRISE
                      ? goToDemo
                      : () => goToSignup(plan.key)
                  }
                />
              ))}
            </div>
          </div>
        </section>

<section id="resources" style={{ padding: "72px 24px", background: "#ffffff" }}>
  <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
    <SectionHeader
      eyebrow="Resources"
      title="ESG, CSRD and AI reporting guides"
      text="Learn how to prepare for CSRD, ESRS and investor-grade ESG reporting with practical guides built for sustainability, finance and leadership teams."
    />

    <div style={featureGridStyle}>
      <ResourceCard
        title="CSRD Reporting Guide"
        text="Understand CSRD requirements, reporting obligations, and readiness steps."
        href="/guides/csrd-reporting"
      />
      <ResourceCard
        title="ESRS Compliance Guide"
        text="Learn how ESRS standards structure sustainability disclosures."
        href="/guides/esrs-compliance"
      />
      <ResourceCard
        title="Double Materiality Guide"
        text="Run a practical double materiality assessment for CSRD reporting."
        href="/guides/double-materiality-assessment"
      />
      <ResourceCard
        title="AI ESG Reporting Guide"
        text="See how AI accelerates ESG reporting and disclosure workflows."
        href="/guides/ai-esg-reporting"
      />
      <ResourceCard
      title="CSRD Readiness Assessment"
      text="Check your organization's CSRD and ESRS readiness in minutes."
      href={ASSESSMENT_PATH}
      />
      <ResourceCard
        title="ESG & CSRD FAQ"
        text="Answers to common ESG, CSRD, ESRS and sustainability reporting questions."
        href="/faq"
      />
    </div>
  </div>
</section>

        <section style={finalCtaStyle}>
          <div style={finalCtaInnerStyle}>
            <div style={finalEyebrowStyle}>Ready to scale ESG reporting?</div>
            <h2 style={finalTitleStyle}>
              Turn sustainability reporting into a strategic advantage.
            </h2>
            <p style={finalTextStyle}>
              Ecovanta helps companies move from reactive compliance to
              investor-grade ESG intelligence with faster reporting cycles,
              clearer gaps, and stronger decision support.
            </p>
            <div style={ctaRowCenteredStyle}>
              <button
                style={finalPrimaryButtonStyle}
                onClick={() => goToSignup(PLAN_KEYS.STARTER)}
              >
                {STARTER_CTA}
              </button>
              <button style={finalSecondaryButtonStyle} onClick={goToDemo}>
                Book Demo
              </button>
            </div>
          </div>
        </section>
      </main>

      <footer style={footerStyle}>
        <div style={footerInnerStyle}>
          <div style={{ maxWidth: "760px" }}>
            <strong style={{ color: "#0f172a" }}>Ecovanta.ai</strong> is a Onedigitale
            AI-powered ESG and CSRD reporting platform designed to help
            organizations improve reporting quality, identify disclosure gaps,
            and deliver investor-grade sustainability outputs.
          </div>
          <div style={footerLinksStyle}>
            <span>© 2026 Onedigitale </span>
            <a href="/terms" style={footerLinkStyle}>
              Terms of Use
            </a>
            <a href="/privacy" style={footerLinkStyle}>
              Privacy Policy
            </a>
            <a href="/guides/csrd-reporting" style={footerLinkStyle}>
              CSRD Guide
            </a>
            <a href="/guides/esrs-compliance" style={footerLinkStyle}>
              ESRS Guide
            </a>
            <a href="/guides/double-materiality-assessment" style={footerLinkStyle}>
              Double Materiality
            </a>
            <a href="/guides/ai-esg-reporting" style={footerLinkStyle}>
              AI ESG Reporting
            </a>
            <a
            href={ASSESSMENT_PATH}
            style={footerLinkStyle}
            onClick={() => trackAssessmentClick("landing_page_footer")}
          >
            CSRD Readiness Assessment
          </a>
            <a href="/faq" style={footerLinkStyle}>
              FAQ
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

function SectionHeader({ eyebrow, title, text }) {
  return (
    <div style={sectionHeaderStyle}>
      <div style={sectionEyebrowStyle}>{eyebrow}</div>
      <h2 style={sectionTitleStyle}>{title}</h2>
      <p style={sectionTextStyle}>{text}</p>
    </div>
  );
}

function FeatureCard({ title, text, icon }) {
  return (
    <div style={featureCardStyle}>
      <div style={featureIconStyle}>{icon}</div>
      <h3 style={featureTitleStyle}>{title}</h3>
      <p style={featureTextStyle}>{text}</p>
    </div>
  );
}

function ResourceCard({ title, text, href }) {
  return (
    <a href={href} style={{ ...featureCardStyle, textDecoration: "none", color: "#0f172a" }}>
      <div style={featureIconStyle}>↗</div>
      <h3 style={featureTitleStyle}>{title}</h3>
      <p style={featureTextStyle}>{text}</p>
      <div style={{ marginTop: "16px", fontWeight: "900", color: "#047857" }}>
        Read guide →
      </div>
    </a>
  );
}

function StepCard({ number, title, text }) {
  return (
    <div style={stepCardStyle}>
      <div style={stepNumberStyle}>{number}</div>
      <h3 style={featureTitleStyle}>{title}</h3>
      <p style={featureTextStyle}>{text}</p>
    </div>
  );
}

function PricingCard({
  name,
  price,
  description,
  features,
  highlighted = false,
  buttonText,
  onAction
}) {
  return (
    <div
      style={{
        ...pricingCardStyle,
        background: highlighted ? "#0f172a" : "#ffffff",
        color: highlighted ? "#ffffff" : "#0f172a",
        border: highlighted ? "1px solid #0f172a" : "1px solid #e5e7eb",
        boxShadow: highlighted
          ? "0 24px 60px rgba(15, 23, 42, 0.22)"
          : "0 12px 30px rgba(15, 23, 42, 0.07)"
      }}
    >
      {highlighted && <div style={popularBadgeStyle}>Most Popular</div>}

      <div
        style={{
          fontSize: "14px",
          fontWeight: "900",
          color: highlighted ? "#c4b5fd" : "#7c3aed",
          marginBottom: "10px",
          textTransform: "uppercase",
          letterSpacing: "0.08em"
        }}
      >
        {name}
      </div>

      <div style={priceStyle}>{price}</div>

      <p
        style={{
          color: highlighted ? "#cbd5e1" : "#475569",
          lineHeight: 1.65,
          minHeight: "58px",
          marginBottom: "22px"
        }}
      >
        {description}
      </p>

      <div style={{ marginTop: "24px", marginBottom: "26px" }}>
        {features.map((feature, index) => (
          <div key={index} style={pricingFeatureRowStyle}>
            <span style={{ color: highlighted ? "#86efac" : "#10b981" }}>
              ✓
            </span>
            <span style={{ color: highlighted ? "#e2e8f0" : "#334155" }}>
              {feature}
            </span>
          </div>
        ))}
      </div>

      <button
        onClick={onAction}
        style={{
          width: "100%",
          padding: "14px 18px",
          borderRadius: "14px",
          border: "none",
          background: highlighted ? "#7c3aed" : "#0f172a",
          color: "#ffffff",
          fontWeight: "900",
          cursor: "pointer",
          fontSize: "15px"
        }}
      >
        {buttonText}
      </button>
    </div>
  );
}

function MetricCard({ title, value, accent }) {
  return (
    <div style={metricCardStyle}>
      <div style={{ color: "#64748b", fontSize: "12px", marginBottom: "6px" }}>
        {title}
      </div>
      <div style={{ fontSize: "26px", fontWeight: "900", color: accent }}>
        {value}
      </div>
    </div>
  );
}

function MiniPanel({ title, children }) {
  return (
    <div style={miniPanelStyle}>
      <div style={{ fontWeight: "900", marginBottom: "10px" }}>{title}</div>
      {children}
    </div>
  );
}

function CheckRow({ text }) {
  return (
    <div style={checkRowStyle}>
      <span style={checkIconStyle}>✓</span>
      <span>{text}</span>
    </div>
  );
}

function MoatItem({ title, text }) {
  return (
    <div style={moatItemStyle}>
      <div style={{ color: "#ffffff", fontWeight: "900", marginBottom: "6px" }}>
        {title}
      </div>
      <div style={{ color: "#cbd5e1", lineHeight: 1.55 }}>{text}</div>
    </div>
  );
}

const headerStyle = {
  position: "sticky",
  top: 0,
  zIndex: 20,
  background: "rgba(248, 250, 252, 0.94)",
  backdropFilter: "blur(14px)",
  borderBottom: "1px solid #e5e7eb"
};

const headerInnerStyle = {
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "16px 24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "16px",
  flexWrap: "wrap"
};

const brandStyle = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  textDecoration: "none",
  color: "#0f172a"
};

const navStyle = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  flexWrap: "wrap"
};

const navLinkStyle = {
  color: "#475569",
  textDecoration: "none",
  fontWeight: "700",
  padding: "8px 10px"
};

const heroSectionStyle = {
  padding: "80px 24px 56px 24px",
  background:
    "radial-gradient(circle at top left, rgba(124, 58, 237, 0.14), transparent 34%), linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)"
};

const heroGridStyle = {
  maxWidth: "1200px",
  margin: "0 auto",
  display: "grid",
  gridTemplateColumns: "minmax(0, 1.08fr) minmax(360px, 0.92fr)",
  gap: "44px",
  alignItems: "center"
};

const eyebrowPillStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  background: "#ede9fe",
  color: "#5b21b6",
  padding: "8px 14px",
  borderRadius: "999px",
  fontSize: "13px",
  fontWeight: "900",
  marginBottom: "18px"
};

const heroTitleStyle = {
  fontSize: "58px",
  lineHeight: 1.02,
  margin: "0 0 18px 0",
  letterSpacing: "-2px",
  maxWidth: "760px"
};

const heroTextStyle = {
  fontSize: "20px",
  lineHeight: 1.7,
  color: "#475569",
  maxWidth: "720px",
  marginBottom: "28px"
};

const ctaRowStyle = {
  display: "flex",
  gap: "14px",
  flexWrap: "wrap",
  marginBottom: "22px"
};

const ctaRowCenteredStyle = {
  display: "flex",
  justifyContent: "center",
  gap: "14px",
  flexWrap: "wrap"
};

const badgeGridStyle = {
  display: "flex",
  gap: "10px",
  flexWrap: "wrap",
  maxWidth: "720px"
};

const trustBadgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  border: "1px solid #d8b4fe",
  background: "rgba(255, 255, 255, 0.78)",
  color: "#334155",
  borderRadius: "999px",
  padding: "8px 12px",
  fontSize: "13px",
  fontWeight: "700"
};

const dashboardShellStyle = {
  background: "#ffffff",
  borderRadius: "26px",
  border: "1px solid #e5e7eb",
  boxShadow: "0 28px 70px rgba(15, 23, 42, 0.14)",
  overflow: "hidden"
};

const dashboardHeaderStyle = {
  background: "#0f172a",
  padding: "16px 18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
};

const metricGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "12px",
  marginBottom: "18px"
};

const metricCardStyle = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: "14px",
  padding: "14px"
};

const recommendationStyle = {
  background: "#f8fafc",
  borderRadius: "16px",
  padding: "16px",
  border: "1px solid #e5e7eb",
  marginBottom: "14px"
};

const recommendationHeaderStyle = {
  display: "flex",
  justifyContent: "space-between",
  gap: "10px",
  alignItems: "center",
  fontWeight: "900",
  marginBottom: "12px"
};

const priorityPillStyle = {
  display: "inline-block",
  background: "#fee2e2",
  color: "#991b1b",
  border: "1px solid #fecaca",
  borderRadius: "999px",
  padding: "4px 10px",
  fontSize: "12px",
  fontWeight: "900"
};

const panelGridStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "14px"
};

const miniPanelStyle = {
  background: "#f8fafc",
  borderRadius: "14px",
  padding: "14px",
  border: "1px solid #e5e7eb"
};

const proofStripStyle = {
  maxWidth: "1200px",
  margin: "0 auto",
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: "22px",
  padding: "26px",
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: "18px",
  boxShadow: "0 14px 36px rgba(15, 23, 42, 0.07)"
};

const proofMetricStyle = {
  borderRight: "1px solid #e5e7eb",
  paddingRight: "18px"
};

const proofValueStyle = {
  fontSize: "34px",
  fontWeight: "900",
  color: "#0f172a",
  letterSpacing: "-0.8px"
};

const proofLabelStyle = {
  color: "#64748b",
  lineHeight: 1.55,
  marginTop: "4px"
};

const investorGridStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "22px",
  alignItems: "stretch"
};

const investorCardStyle = {
  background: "#ffffff",
  borderRadius: "22px",
  padding: "28px",
  border: "1px solid #e5e7eb",
  boxShadow: "0 14px 36px rgba(15, 23, 42, 0.07)"
};

const moatCardStyle = {
  background: "#0f172a",
  borderRadius: "22px",
  padding: "28px",
  border: "1px solid #1e293b",
  boxShadow: "0 20px 50px rgba(15, 23, 42, 0.22)"
};

const moatListStyle = {
  display: "grid",
  gap: "14px"
};

const moatItemStyle = {
  background: "rgba(255, 255, 255, 0.06)",
  border: "1px solid rgba(255, 255, 255, 0.10)",
  borderRadius: "16px",
  padding: "16px"
};

const cardTitleStyle = {
  margin: "0 0 12px 0",
  color: "#0f172a",
  fontSize: "24px",
  letterSpacing: "-0.4px"
};

const cardTextStyle = {
  margin: 0,
  color: "#475569",
  lineHeight: 1.7,
  fontSize: "16px"
};

const checkRowStyle = {
  display: "flex",
  gap: "10px",
  color: "#334155",
  lineHeight: 1.55
};

const checkIconStyle = {
  color: "#10b981",
  fontWeight: "900",
  flex: "0 0 auto"
};

const whiteSectionStyle = {
  padding: "72px 24px",
  background: "#ffffff",
  borderTop: "1px solid #e5e7eb",
  borderBottom: "1px solid #e5e7eb"
};

const sectionHeaderStyle = {
  marginBottom: "34px",
  maxWidth: "820px"
};

const sectionEyebrowStyle = {
  color: "#7c3aed",
  fontSize: "14px",
  fontWeight: "900",
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  marginBottom: "10px"
};

const sectionTitleStyle = {
  fontSize: "42px",
  lineHeight: 1.12,
  margin: "0 0 12px 0",
  color: "#0f172a",
  letterSpacing: "-1px"
};

const sectionTextStyle = {
  margin: 0,
  color: "#475569",
  lineHeight: 1.7,
  fontSize: "18px"
};

const featureGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const featureCardStyle = {
  background: "#ffffff",
  borderRadius: "18px",
  padding: "24px",
  boxShadow: "0 10px 28px rgba(15, 23, 42, 0.07)",
  border: "1px solid #e5e7eb",
  height: "100%"
};

const featureIconStyle = {
  width: "48px",
  height: "48px",
  borderRadius: "14px",
  background: "#ede9fe",
  color: "#5b21b6",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "14px",
  fontWeight: "900",
  marginBottom: "16px"
};

const featureTitleStyle = {
  margin: "0 0 10px 0",
  fontSize: "20px",
  color: "#0f172a",
  letterSpacing: "-0.3px"
};

const featureTextStyle = {
  margin: 0,
  color: "#475569",
  lineHeight: 1.65,
  fontSize: "15px"
};

const stepGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: "20px"
};

const stepCardStyle = {
  background: "#ffffff",
  borderRadius: "18px",
  padding: "24px",
  border: "1px solid #e5e7eb",
  boxShadow: "0 10px 28px rgba(15, 23, 42, 0.06)"
};

const stepNumberStyle = {
  width: "50px",
  height: "50px",
  borderRadius: "999px",
  background: "#7c3aed",
  color: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "900",
  marginBottom: "16px"
};

const darkBandStyle = {
  padding: "72px 24px",
  background: "#0f172a",
  color: "#ffffff"
};

const darkBandGridStyle = {
  maxWidth: "1200px",
  margin: "0 auto",
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "34px",
  alignItems: "center"
};

const darkEyebrowStyle = {
  color: "#c4b5fd",
  fontSize: "14px",
  fontWeight: "900",
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  marginBottom: "12px"
};

const darkTitleStyle = {
  fontSize: "42px",
  lineHeight: 1.12,
  margin: "0 0 14px 0",
  letterSpacing: "-1px"
};

const darkTextStyle = {
  color: "#cbd5e1",
  lineHeight: 1.75,
  fontSize: "18px",
  margin: 0
};

const securityGridStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "14px"
};

const securityItemStyle = {
  background: "rgba(255, 255, 255, 0.07)",
  border: "1px solid rgba(255, 255, 255, 0.11)",
  borderRadius: "16px",
  padding: "18px",
  fontWeight: "900"
};

const pricingGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
  gap: "20px",
  alignItems: "stretch"
};

const pricingCardStyle = {
  borderRadius: "22px",
  padding: "28px",
  position: "relative",
  height: "100%"
};

const popularBadgeStyle = {
  position: "absolute",
  top: "-12px",
  right: "20px",
  background: "#7c3aed",
  color: "#ffffff",
  borderRadius: "999px",
  padding: "6px 12px",
  fontSize: "12px",
  fontWeight: "900"
};

const priceStyle = {
  fontSize: "36px",
  fontWeight: "900",
  marginBottom: "12px",
  letterSpacing: "-0.8px"
};

const pricingFeatureRowStyle = {
  display: "flex",
  alignItems: "flex-start",
  gap: "10px",
  marginBottom: "12px",
  lineHeight: 1.55
};

const finalCtaStyle = {
  padding: "76px 24px",
  background:
    "linear-gradient(135deg, #0f172a 0%, #312e81 52%, #5b21b6 100%)",
  color: "#ffffff"
};

const finalCtaInnerStyle = {
  maxWidth: "980px",
  margin: "0 auto",
  textAlign: "center"
};

const finalEyebrowStyle = {
  color: "#c4b5fd",
  fontSize: "14px",
  fontWeight: "900",
  marginBottom: "14px",
  textTransform: "uppercase",
  letterSpacing: "0.08em"
};

const finalTitleStyle = {
  fontSize: "44px",
  lineHeight: 1.12,
  margin: "0 0 16px 0",
  letterSpacing: "-1px"
};

const finalTextStyle = {
  maxWidth: "760px",
  margin: "0 auto 28px auto",
  color: "#e2e8f0",
  fontSize: "18px",
  lineHeight: 1.7
};

const footerStyle = {
  padding: "30px 24px",
  background: "#ffffff",
  borderTop: "1px solid #e5e7eb"
};

const footerInnerStyle = {
  maxWidth: "1200px",
  margin: "0 auto",
  display: "flex",
  justifyContent: "space-between",
  gap: "18px",
  flexWrap: "wrap",
  color: "#64748b",
  fontSize: "14px",
  lineHeight: 1.6
};

const footerLinksStyle = {
  display: "flex",
  gap: "14px",
  flexWrap: "wrap",
  alignItems: "center"
};

const footerLinkStyle = {
  color: "#475569",
  textDecoration: "none",
  fontWeight: "700"
};

const primaryButtonStyle = {
  padding: "10px 16px",
  borderRadius: "12px",
  border: "none",
  background: "#7c3aed",
  color: "#ffffff",
  fontWeight: "900",
  cursor: "pointer"
};

const secondaryButtonStyle = {
  padding: "10px 16px",
  borderRadius: "12px",
  border: "1px solid #d1d5db",
  background: "#ffffff",
  color: "#0f172a",
  fontWeight: "900",
  cursor: "pointer"
};

const primaryButtonLargeStyle = {
  padding: "15px 22px",
  borderRadius: "15px",
  border: "none",
  background: "#7c3aed",
  color: "#ffffff",
  fontWeight: "900",
  cursor: "pointer",
  fontSize: "15px",
  boxShadow: "0 14px 30px rgba(124, 58, 237, 0.26)"
};

const secondaryButtonLargeStyle = {
  padding: "15px 22px",
  borderRadius: "15px",
  border: "1px solid #d1d5db",
  background: "#ffffff",
  color: "#0f172a",
  fontWeight: "900",
  cursor: "pointer",
  fontSize: "15px"
};

const finalPrimaryButtonStyle = {
  padding: "15px 24px",
  borderRadius: "15px",
  border: "none",
  background: "#ffffff",
  color: "#4c1d95",
  fontWeight: "900",
  cursor: "pointer",
  fontSize: "15px"
};

const finalSecondaryButtonStyle = {
  padding: "15px 24px",
  borderRadius: "15px",
  border: "1px solid rgba(255, 255, 255, 0.40)",
  background: "transparent",
  color: "#ffffff",
  fontWeight: "900",
  cursor: "pointer",
  fontSize: "15px"
};

const barRow = {
  display: "grid",
  gridTemplateColumns: "100px 1fr",
  gap: "10px",
  alignItems: "center",
  marginBottom: "10px",
  fontSize: "14px",
  color: "#475569"
};

const barTrack = {
  width: "100%",
  height: "10px",
  background: "#e5e7eb",
  borderRadius: "999px",
  overflow: "hidden"
};

const barFill = {
  height: "100%",
  borderRadius: "999px"
};

const dot = (color) => ({
  width: "10px",
  height: "10px",
  borderRadius: "999px",
  background: color,
  display: "inline-block"
});